import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

export const redirectUrlGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const redirectUrl = route.queryParams['redirectUrl'];

  authService.redirectUrl = redirectUrl;

  if (!redirectUrl) router.navigate(['lost-redirectUrl']);
  return true;
};

export const verificationGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const redirectUrl = route.queryParams['redirectUrl'];

  authService.redirectUrl = redirectUrl;
  if (!redirectUrl) router.navigate(['lost-redirectUrl']);

  return true;
};

export const googleConfirmationGuard: CanActivateFn = (route, state) => {
  const redirectUrl = route.queryParams['redirectUrl'];
  const router = inject(Router);
  const code = route.queryParams['code'];
  const authService = inject(AuthService);

  if (!redirectUrl) router.navigate(['lost-redirectUrl']);

  if (!code) {
    authService.init();
    router.navigate(['/inappropriate-approach']);
    return false;
  }

  return true;
};

export const preventDuplicateLoginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const redirectUrl = route.queryParams['redirectUrl'];
  if (authService.accessToken) {
    router.navigate(['/prevent-duplicate-login'], { queryParams: { redirectUrl: redirectUrl } });
    return false;
  }

  return true;
};
